"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_DISCHARGE_PERMISSIONS = exports.DischargePermissions = void 0;
/**
 * DISCHARGE MODULE permissions.
 *
 * The Discharge workspace is a DESK, not a second place to do the IP acts. Advising a discharge, settling the bill,
 * completing the discharge, recording the exit and cancelling a discharge keep the `ip:*` permission they have always
 * carried (`ip:discharge:advise|complete|exit|cancel`, `ip:settlement:settle`): the Discharge screens call the same
 * endpoints, and show each button only to a holder of the same key. Nothing here widens who may END A STAY.
 *
 * What is new, and why each is its own key:
 *
 *   discharge:desk:view       open the Discharge pages and read the pipeline, the register and one stay's discharge file.
 *                             It carries the stay's BALANCE (the one figure a discharge hangs on) and nothing else
 *                             financial — no charge lines, no settlement detail — so a discharge coordinator needs no
 *                             billing permission to do the job.
 *   discharge:checklist:sign  record, or take back, a department's clearance on a stay (nursing, pharmacy, ...). Its own
 *                             key because signing a clearance is a statement about care, and the person who may read the
 *                             file is not thereby the person who may attest to it.
 *   discharge:labreport:view  read ONE stay's released laboratory reports, combined and date-wise, by bill number. Its
 *                             own key, deliberately NOT `lab:report:view`: that one opens the laboratory's whole worklist
 *                             of every patient, and a discharge desk must be able to assemble a patient's file without
 *                             being handed the laboratory.
 *   discharge:labreport:print download / print that combined report as a PDF. Separate from viewing for the reason
 *                             `ip:report:export` is separate from `ip:report:view`: a copy leaves the screen's access
 *                             control, and each copy is written to the audit trail.
 *
 * Kept to FOUR on purpose: every permission is embedded in every JWT, and that has already hit Node's and nginx's header
 * limits twice. Every key is a strict 3-segment `discharge:resource:action`.
 *
 * Adding this family takes TWO edits, not one — `PermissionService.seedDischargeCatalog()` and its name in
 * `scripts/deploy-seed-all-catalogs.ts`; without the second every route below answers 403 to everyone, SuperAdmin
 * included (the BUG-0006 shape). `discharge-permission-catalog.test.ts` asserts both.
 */
exports.DischargePermissions = {
    DISCHARGE_DESK_VIEW: 'discharge:desk:view',
    DISCHARGE_CHECKLIST_SIGN: 'discharge:checklist:sign',
    DISCHARGE_LAB_REPORT_VIEW: 'discharge:labreport:view',
    DISCHARGE_LAB_REPORT_PRINT: 'discharge:labreport:print',
};
exports.ALL_DISCHARGE_PERMISSIONS = Object.values(exports.DischargePermissions);
//# sourceMappingURL=discharge.permissions.js.map